var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.show,
        title: _vm.$t("TABLE_HEADER_fileNameList"),
        "close-on-click-modal": false,
        "append-to-body": "",
        "max-height": "500",
        width: "70%",
        top: "10vh",
      },
      on: { close: _vm.close },
    },
    [
      _c(
        "div",
        { staticClass: "filelist-container" },
        [
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.pageData,
                border: "",
                "max-height": "500",
                "row-class-name": _vm.tableRowClassName,
                "cell-class-name": _vm.tableCellClassName,
              },
            },
            [
              _vm.getUser.userType === "1"
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("milestone_file_visible_to_client"),
                      "header-align": "center",
                      width: "60",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("img", {
                                class: [
                                  "visible_to_client-icon",
                                  !scope.row.isEditVisible ||
                                  scope.row.uploadUserType === "2"
                                    ? "visible_to_client-icon-uneditable"
                                    : "",
                                ],
                                attrs: {
                                  src: _vm.calcVisibleIcon(scope.row),
                                  alt: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.changeVisiableToClient(scope.row)
                                  },
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3809051223
                    ),
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("DOWNLOAD_FILE_NAME"),
                  "header-align": "center",
                  "min-width": "150",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            class: [
                              "filename",
                              !_vm.canDownload(scope.row)
                                ? "filename-disable"
                                : "",
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.onFilenameClick(scope.row)
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "filename-icon el-icon-download",
                            }),
                            _c("span", { staticClass: "filename-text" }, [
                              _vm._v(_vm._s(scope.row.uploadFilename)),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm.getUser.userType === "1"
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("table_column_lable_milestone"),
                      "header-align": "center",
                      "min-width": "150",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(scope.row.multiMilestoneName) +
                                  "\n                    "
                              ),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: scope.row.accessFlag == "0",
                                      expression: "scope.row.accessFlag == '0'",
                                    },
                                  ],
                                  staticClass: "forkpmgonly",
                                },
                                [_vm._v(_vm._s(_vm.$t("for_kpmg_only")))]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2934592705
                    ),
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("DOWNLOAD_SIZE"),
                  "header-align": "center",
                  align: "center",
                  width: "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm._f("fileSize")(scope.row.size)) +
                            "\n                "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("DOWNLOAD_TIME"),
                  "header-align": "center",
                  align: "center",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm._f("formatDateTime")(
                                scope.row.lastDownloadDate
                              )
                            ) +
                            "\n                "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("DOWNLOAD_BY"),
                  prop: "lastDownloadBy",
                  "header-align": "center",
                  align: "center",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("UPLOAD_TIME"),
                  "header-align": "center",
                  align: "center",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm._f("formatDateTime")(scope.row.createDate)
                            ) +
                            "\n                "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("UPLOAD_BY"),
                  prop: "createBy",
                  "header-align": "center",
                  align: "center",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "action",
                  width: "70",
                  "show-overflow-tooltip": "",
                  align: "center",
                  label: _vm.$t("COMMON_DELETE"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.allowDelete(scope.row)
                          ? _c("i", {
                              staticClass: "el-icon-delete delete",
                              on: {
                                click: function ($event) {
                                  return _vm.onDeleteClick(scope.row)
                                },
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("el-pagination", {
            staticClass: "wl-pagination",
            attrs: {
              total: _vm.filelist.length,
              "page-size": _vm.pageSize,
              "page-sizes": [10, 50, 100],
              layout: "prev, pager, next, sizes, total",
            },
            on: {
              "size-change": _vm.onSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }